import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import CategorySection from './components/CategorySection';
import RecommendedSection from './components/RecommendedSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国漫画网',
    url: 'https://rhmeiji.cn',
    description: '韩国漫画网提供免费的韩漫在线观看和下拉式韩漫大全阅读，提供便捷访问方式，让您随时随地沉浸于多样漫画世界无需成本。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@rhmeiji.cn',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const webpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩国漫画网 - 韩漫在线观看 - 下拉式韩漫大全 - 免费韩漫阅读',
    description: '在韩国漫画网，体验免费的韩漫在线观看和下拉式韩漫大全阅读，提供便捷访问方式，让您随时随地沉浸于多样漫画世界无需成本。',
    url: 'https://rhmeiji.cn',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://rhmeiji.cn',
    },
    primaryImageOfPage: {
      '@type': 'ImageObject',
      url: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20platform%20hero%20background&width=1920&height=1080&seq=hero-bg-manhwa&orientation=landscape',
    },
  };

  return (
    <>
      <ScrollToTop />
      <title>韩国漫画网 - 韩漫在线观看 - 下拉式韩漫大全 - 免费韩漫阅读</title>
      <meta name="description" content="在韩国漫画网，体验免费的韩漫在线观看和下拉式韩漫大全阅读。提供便捷访问方式，让您随时随地沉浸于多样漫画世界无需成本。海量韩国漫画、每日更新、完全免费。" />
      <meta name="keywords" content="韩国漫画网, 韩漫在线观看, 下拉式韩漫大全, 免费韩漫阅读, 韩国漫画, 漫画在线阅读" />
      <link rel="canonical" href="https://rhmeiji.cn" />
      <meta property="og:title" content="韩国漫画网 - 韩漫在线观看 - 下拉式韩漫大全 - 免费韩漫阅读" />
      <meta property="og:description" content="在韩国漫画网，体验免费的韩漫在线观看和下拉式韩漫大全阅读，提供便捷访问方式，让您随时随地沉浸于多样漫画世界无需成本。" />
      <meta property="og:url" content="https://rhmeiji.cn" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="韩国漫画网" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="韩国漫画网 - 韩漫在线观看 - 下拉式韩漫大全 - 免费韩漫阅读" />
      <meta name="twitter:description" content="在韩国漫画网，体验免费的韩漫在线观看和下拉式韩漫大全阅读，提供便捷访问方式，让您随时随地沉浸于多样漫画世界无需成本。" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedComics />
          <LatestUpdates />
          <CategorySection />
          <RecommendedSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}